"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBlockV2 = void 0;
const node_1 = require("../node");
const isBlockV2 = (block) => (0, node_1.isNodeV2)(block === null || block === void 0 ? void 0 : block.schema.nodes[block === null || block === void 0 ? void 0 : block.schema.rootId]);
exports.isBlockV2 = isBlockV2;
